module.exports = __webpack_public_path__ + "img/logo-b-w.736f50b3.svg";